import { internalClient } from "./internalClient";
import type { TAvailabilitySlotsResponse } from "../types/availableSlots";

type TGetAvailabilitySlotsParams = {
    shop: string;
    date: string;
}

export async function getAvailabilitySlots(params: TGetAvailabilitySlotsParams): Promise<TAvailabilitySlotsResponse> {
    const response = await internalClient.post('', {
        action: 'getSlots',
        ...params,
    })

    return response.data
}